export const LOAD_CATEGORIES = 'category/LOAD_CATEGORIES'
export const LOAD_CATEGORIES_SUCCESS = 'category/LOAD_CATEGORIES_SUCCESS'
export const LOAD_CATEGORIES_FAILED = 'category/LOAD_CATEGORIES_FAILED'
